// extracted by mini-css-extract-plugin
module.exports = {"phone":"Mobile_phone__ZbFyG","close":"Mobile_close__hJNXJ","line":"Mobile_line__hMBT7"};